export const TICKETCOMPLEXITIES = ["VERYLOW", "LOW", "NORMAL", "HIGH", "VERYHIGH", "URGENT"]
